import { useEffect } from 'react';

/**
 * @param {boolean} disableScroll - Whether to disable body scrolling.
 */
const useBodyOverflow = (disableScroll) => {
  useEffect(() => {
    // Set body overflow based on the passed value
    document.body.style.overflow = disableScroll ? 'hidden' : ''; // removed 'auto'

    // Cleanup function to reset body overflow when the hook is unmounted
    return () => {
      document.body.style.overflow = ''; // removed 'auto'
    };
  }, [disableScroll]);
};

export default useBodyOverflow;
